import { ApiError } from '../types/api';

export interface DuplicateCultivar {
  id: number;
  name: string;
}

// The server refuses a second cultivar with a name the organisation already
// has for the crop (409 CULTIVAR_EXISTS, ignoring case, spaces and
// punctuation) and names the one it has. Each organisation keeps its own
// register, so that one is what to open instead.
export function duplicateCultivarOf(err: unknown): DuplicateCultivar | null {
  if (!(err instanceof ApiError) || err.code !== 'CULTIVAR_EXISTS') return null;
  const existing = (err.details as { existing?: DuplicateCultivar } | undefined)?.existing;
  return existing && typeof existing.id === 'number' ? existing : null;
}
